/**
 * Vem får se och göra vad med ett möte. Rena funktioner; anroparen (en
 * Netlify-funktion med service_role) hämtar `arDeltagare` ur mote_deltagare.
 * Tabellerna har inga RLS-policys, så det här är den enda grinden.
 */
import type { Atkomst, Mote } from './typer';

export type Anvandare = { id: string; arAdmin: boolean };

/**
 * intern_alla: innehållet är öppet för alla inloggade. Övriga typer: ägare och
 * deltagare. Admin utan åtkomst ser bara metadata (rubrik, datum, typ, ägare,
 * status) – aldrig innehållet. En borttagen deltagare (`arDeltagare=false`)
 * tappar åtkomsten direkt.
 */
export function atkomst(
  m: Pick<Mote, 'typ' | 'agare'>,
  anvandare: Anvandare,
  arDeltagare: boolean,
): Atkomst {
  if (m.typ === 'intern_alla') return 'allt';
  if (m.agare === anvandare.id || arDeltagare) return 'allt';
  return anvandare.arAdmin ? 'metadata' : 'ingen';
}

/**
 * Typ, deltagare och talarnamn ändras bara av ägaren. Kunskapsbasen (lagg_i_kb)
 * är undantaget (ruling R9): ägaren ELLER en admin som själv har åtkomst till
 * innehållet (atkomst 'allt') – se behorighetFor i api.ts.
 */
export function kanAndra(m: Pick<Mote, 'agare'>, anvandare: Anvandare): boolean {
  return m.agare === anvandare.id;
}

export function kanRadera(m: Pick<Mote, 'agare'>, anvandare: Anvandare): boolean {
  return m.agare === anvandare.id || anvandare.arAdmin;
}

/** Kundmöten aldrig; bara färdigsammanfattade möten (aldrig hela utskriften). */
export function kanLaggaIKb(m: Pick<Mote, 'typ' | 'status'>): boolean {
  return m.typ !== 'kund' && m.status === 'sammanfattad';
}
